import { useState } from 'react';
import type { IFilterBadge } from '@/components/FilterBadgesList';
import type { QueryParamsInterface } from '@/types/Shared';

interface IFiltersFormData {
  [key: string]: { label: string; value: string | number };
}

export const useFilters = () => {
  const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
  const [appliedFilters, setAppliedFilters] = useState<QueryParamsInterface>({});
  const [filterBadges, setFilterBadges] = useState<IFilterBadge>({});

  const applyFiltersHandler = (filters: QueryParamsInterface, filterBadgesData?: IFiltersFormData) => {
    setAppliedFilters((prevState) => ({ ...prevState, ...filters }));
    if (filterBadgesData) {
      setFilterBadges((prevState) => ({
        ...prevState,
        ...filterBadgesData,
      }));
    }
    setShowFilterModal(false);
  };

  const removeFilterHandler = (filterKey: string) => {
    const updatedAppliedFilters = { ...appliedFilters };
    delete updatedAppliedFilters[filterKey as keyof typeof appliedFilters];

    setAppliedFilters({ ...updatedAppliedFilters });

    const updatedDisplayFilters = { ...filterBadges };
    delete updatedDisplayFilters[filterKey as keyof typeof filterBadges];

    setFilterBadges({ ...updatedDisplayFilters });
  };

  const toggleFilterModal = () => {
    setShowFilterModal((prevState) => !prevState);
  };
  return {
    showFilterModal,
    appliedFilters,
    filterBadges,
    toggleFilterModal,
    applyFiltersHandler,
    removeFilterHandler,
  };
};
